exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page-title {\n  overflow: hidden;\n  line-height: 0.4rem;\n  font-size: 0.28rem;\n  color: #324057;\n}\n.page-title .icon {\n  float: left;\n  position: relative;\n  margin: 0.04rem 0.1rem 0.06rem 0;\n}\n.page-title .el-breadcrumb {\n  float: left;\n  display: inline-block;\n  font-size: 0.28rem;\n  color: #324057;\n  line-height: normal;\n}\n.page-title .default:last-child .el-breadcrumb__item__inner:hover {\n  color: #97a8be;\n  cursor: text;\n}\n.page-title .default .el-breadcrumb__item__inner:hover {\n  color: #48576a;\n  cursor: text;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bd5946f","scoped":false,"hasInlineConfig":false}!./~/postcss-loader/lib?sourceMap!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/PageTitle/index.vue
// module id = 837
// module chunks = 3 7 8 9 11 12 13 14 16 19 20 23 24 25 26 28 29